import { apiGet, apiPost, apiPatch, apiDelete } from './client'

export async function getAllUsers(
  token: string,
  filters?: Record<string, any>,
) {
  const params = new URLSearchParams()
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== '') {
        params.append(key, String(value))
      }
    })
  }
  const qs = params.toString()
  return apiGet(`/admin/users/all${qs ? `?${qs}` : ''}`, token)
}

export async function createUser(token: string, data: any) {
  return apiPost('/admin/users/create', token, data)
}

export async function updateUserStatus(
  token: string,
  userId: string,
  status: string,
) {
  return apiPatch(`/admin/users/${userId}/status`, token, { status })
}

export async function deleteUser(token: string, userId: string) {
  return apiDelete(`/admin/users/${userId}`, token)
}
